import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Search as SemanticSearch } from 'semantic-ui-react';
import './Search.css';

class Search extends Component {
    static propTypes = {
        commandGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
        eventGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
        // react-router injected props via 'withRouter'
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.state = {
            results: [],
            value: ''
        };

        this.handleResultSelect = this.handleResultSelect.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    resetComponent() {
        this.setState({ results: [], value: '' });
    }

    handleResultSelect(e, result) {
        this.setState({ value: result.title });
        this.props.history.push(result.link);
    }

    handleSearchChange(e, value) {
        this.setState({
            value
        });

        if (value.length < 1) {
            this.resetComponent();
            return;
        }

        const filteredResults = {
            commands: {
                name: "Commands",
                results: []
            },
            events: {
                name: "Events",
                results: []
            }
        };

        const isMatch = name => name.toLowerCase().indexOf(value.toLowerCase()) !== -1;

        for (const group of this.props.commandGroups) {
            for (const command of group.values) {
                if (!isMatch(command.name)) {
                    continue;
                }

                const result = {
                    title: command.name,
                    description: command.description,
                    link: `/commands/${group.name}/${command.name}`
                };

                filteredResults.commands.results.push(result);
            }
        }

        for (const group of this.props.eventGroups) {
            for (const event of group.values) {
                if (!isMatch(event.name)) {
                    continue;
                }

                const result = {
                    title: event.name,
                    description: event.description,
                    link: `/events/${group.name}/${event.name}`
                };

                filteredResults.events.results.push(result);
            }
        }

        // We don't want to display an empty category in the results
        if (!filteredResults.commands.results.length) {
            delete filteredResults.commands;
        }
        if (!filteredResults.events.results.length) {
            delete filteredResults.events;
        }

        this.setState({
            results: filteredResults
        });
    }

    componentDidUpdate(){
        var path = window.location.hash;
        var re = /\/(commands|events)\/[^\/]+\/([^\/]+)/i;
        var found = path.match(re);
        if (found) {
            var element = document.getElementById(found[2]);
            element.scrollIntoView();
        }
    }

    render() {
        const { value, results } = this.state;

        return (
            <SemanticSearch
                category
                onResultSelect={this.handleResultSelect}
                onSearchChange={this.handleSearchChange}
                results={results}
                value={value}
            />
        );
    }
};

export default withRouter(Search);
